import { NgModule } from '@angular/core';
import { Routes, RouterModule,ExtraOptions  } from '@angular/router';
import { IstComponent } from './ist/ist.component';
import { GrantsComponent } from './grants/grants.component';
import { UmComponent } from './um/um.component';
import { EapComponent } from './eap/eap.component';

import { IstRegistrationsComponent } from './ist/ist-registrations/ist-registrations.component';
import { IstApplicationsComponent } from './ist/ist-applications/ist-applications.component';
import { IstMyApplicationsComponent } from './ist/ist-my-applications/ist-my-applications.component';
import { IstApplicationExtComponent } from './ist/ist-application-ext/ist-application-ext.component';
import { IstGeneralInformationComponent } from './ist/ist-application-ext/ist-general-information/ist-general-information.component';
import { IstStudyTeamTeamComponent } from './ist/ist-application-ext/ist-study-team-team/ist-study-team-team.component';
import { UmOrganizationComponent } from './um/um-organization/um-organization.component';
import { UmDepartmentComponent } from './um/um-department/um-department.component';
import { UmRoleComponent } from './um/um-role/um-role.component';
import { UmUserComponent } from './um/um-user/um-user.component';
import { AdministrationComponent } from './administration/administration.component';
import { PersonalizationComponent } from './personalization/personalization.component';
import { ChangeThemeComponent } from './personalization/change-theme/change-theme.component';
import { ChangePasswordComponent } from './personalization/change-password/change-password.component';
import { ViewProfileComponent } from './personalization/view-profile/view-profile.component';
import { LoginComponent } from './common/login/login.component';
import { AuthGuard } from './services/auth.guard';
import { HomeComponent } from './home/home.component';
import { IstStudyTeamOrganizationComponent } from './ist/ist-application-ext/ist-study-team-organization/ist-study-team-organization.component';
import { IstMilestonesComponent } from './ist/ist-application-ext/ist-milestones/ist-milestones.component';
import { IstAmendmentsComponent } from './ist/ist-application-ext/ist-amendments/ist-amendments.component';
import { IstSiteEvluationComponent } from './ist/ist-application-ext/ist-site-evaluation/ist-site-evluation.component';
import { IstStudyReportsComponent } from './ist/ist-application-ext/ist-study-reports/ist-study-reports.component';
import { IstActivitiesSeminarsComponent } from './ist/ist-application-ext/ist-activities-seminars/ist-activities-seminars.component';
import { IstPublicationsComponent } from './ist/ist-application-ext/ist-publications/ist-publications.component';
import { IstInstitutionalReviewBoardComponent } from './ist/ist-application-ext/ist-institutional-review-board/ist-institutional-review-board.component';
import { IstConceptProposalComponent } from './ist/ist-application-ext/ist-concept-proposal/ist-concept-proposal.component';
import { AttachmentsComponent } from './common/attachments/attachments.component';
import { RfiComponent } from './common/rfi/rfi.component';
import { NotesComponent } from './common/notes/notes.component';
import { GrantsGeneralInformationComponent } from './grants/grants-application-ext/grants-general-information/grants-general-information.component';
import { GrantsGrantInformationComponent } from './grants/grants-application-ext/grants-grant-information/grants-grant-information.component';
import { GrantsLetterOfIntentComponent } from './grants/grants-application-ext/grants-letter-of-intent/grants-letter-of-intent.component';
import { GrantsUserInstructionsComponent } from './grants/grants-application-ext/grants-user-instructions/grants-user-instructions.component';
import { GrantsDeliveryFormatComponent } from './grants/grants-application-ext/grants-delivery-format/grants-delivery-format.component';
import { GrantsAudiencesComponent } from './grants/grants-application-ext/grants-audiences/grants-audiences.component';
import { GrantsBudgetComponent } from './grants/grants-application-ext/grants-budget/grants-budget.component';
import { GrantsAuthorizedSigneeAndPayeeComponent } from './grants/grants-application-ext/grants-authorized-signee-and-payee/grants-authorized-signee-and-payee.component';
import { GrantsOutcomeAssessmentComponent } from './grants/grants-application-ext/grants-outcome-assessment/grants-outcome-assessment.component';
import { GrantsReconciliationComponent } from './grants/grants-application-ext/grants-reconciliation/grants-reconciliation.component';
import { GrantsDocumentUploadComponent } from './grants/grants-application-ext/grants-document-upload/grants-document-upload.component';
import { GrantsRegistrationsComponent } from './grants/grants-registrations/grants-registrations.component';
import { GrantsApplicationsComponent } from './grants/grants-applications/grants-applications.component';
import { GrantsMyApplicationsComponent } from './grants/grants-my-applications/grants-my-applications.component';
import { GrantsApplicationExtComponent } from './grants/grants-application-ext/grants-application-ext.component';
import { EapApplicationsComponent } from './eap/eap-applications/eap-applications.component';
import { EapMyApplicationsComponent } from './eap/eap-my-applications/eap-my-applications.component';
import { EapProgramInfoComponent } from './eap/eap-application-ext/eap-program-info/eap-program-info.component';
import { CorrespondenceComponent } from './common/correspondence/correspondence.component';
import { NotificationStoreComponent } from './administration/notification-store/notification-store.component';
import { LookupsComponent } from './administration/lookups/lookups.component';
import { ProductComponent } from './administration/product/product.component';
import { ProgramComponent } from './administration/program/program.component';
import { CCodeComponent } from './administration/c-code/c-code.component';
import { LdapConfigurationComponent } from './administration/ldap-configuration/ldap-configuration.component';
import { SamlSsoConfigurationComponent } from './administration/saml-sso-configuration/saml-sso-configuration.component';
import { ForgotPasswordComponent } from './common/forgot-password/forgot-password.component';
import { EapTypeComponent } from './administration/eap-type/eap-type.component';
import { FaqViewComponent } from './common/faq-view/faq-view.component';
import { DocumentTemplateComponent } from './common/document-template/document-template.component';

import { IstAllRequestsComponent } from './ist/ist-application-ext/ist-all-requests/ist-all-requests.component';
import { InstructionsComponent } from './administration/instructions/instructions.component';
import { FaqComponent } from './administration/faq/faq.component';
import { PolicyConfiguratorComponent } from './administration/policy-configurator/policy-configurator.component';
import { ScreenRepositoryComponent } from './administration/screen-repository/screen-repository.component';
import { GrantsDocumentUploadSponsorshipComponent } from './grants/grants-application-ext/grants-document-upload-sponsorship/grants-document-upload-sponsorship.component';
import { GrantsGeneralInformationSponsorshipComponent } from './grants/grants-application-ext/grants-general-information-sponsorship/grants-general-information-sponsorship.component';
import { GrantsGeneralInformationCharitableComponent } from './grants/grants-application-ext/grants-general-information-charitable/grants-general-information-charitable.component';
import { IstDocumentTemplateDefinitionComponent } from './common/ist-document-template-definition/ist-document-template-definition.component';
import { ErrorPageComponent } from './common/error-page/error-page.component';
import { DynamicFormsComponent } from './common/dynamic-forms/dynamic-forms.component';
import { ProductNetworkLocationsComponent } from './administration/product-network-locations/product-network-locations.component';
import { HlookupsComponent } from './administration/hlookups/hlookups.component';
import { LoginLogComponent } from './common/loginlog/loginlog.component';
import { EapStudyTeamTeamComponent } from './eap/eap-application-ext/eap-study-team-team/eap-study-team-team.component';
import { EapStudyTeamOrganizationComponent } from './eap/eap-application-ext/eap-study-team-organization/eap-study-team-organization.component';
import { EapStudyReportsComponent } from './eap/eap-application-ext/eap-study-reports/eap-study-reports.component';
import { EapAmendmentsComponent } from './eap/eap-application-ext/eap-amendments/eap-amendments.component';
import { EapInstitutionalReviewBoardComponent } from './eap/eap-application-ext/eap-institutional-review-board/eap-institutional-review-board.component';
import { EapAllRequestsComponent } from './eap/eap-application-ext/eap-ist-all-requests/eap-all-requests.component';
import { EapApplicationExtComponent } from './eap/eap-application-ext/eap-application-ext.component';
import { GeneraloverviewComponent } from './common/generaloverview/generaloverview.component';
import { ListingComponent } from './common/listing/listing.component';
import { AdminConsoleComponent } from './administration/admin-console/admin-console.component';
import { SuperAdminAuditLogComponent } from './um/super-admin-audit-log/super-admin-audit-log.component';
import { AdminAuditlogMainComponent } from './administration/admin-auditlog-main/admin-auditlog-main.component';
import { ExpandEmailComponent } from './common/correspondence/expand-email/expand-email.component';
import { SuperAdminEmailconfigComponent } from './um/super-admin-emailconfig/super-admin-emailconfig.component';
import { AlertsAndNotificationsSummaryComponent } from './common/alerts-and-notifications-summary/alerts-and-notifications-summary.component';
import { IEGAuditlogMainComponent } from './common/ieg-auditlog-main/ieg-auditlog-main.component';
import { EmailSetUpSummaryComponent } from './administration/email-set-up-summary/email-set-up-summary.component';
import { EmailTemplatesSummaryComponent } from './administration/email-templates-summary/email-templates-summary.component';
import { ConfigurePolicyModalComponent } from './administration/policy-configurator/configure-policy-modal/configure-policy-modal.component';
import { FilePreviewComponent } from './common/document-summary/file-preview/file-preview.component';
import { DeactivateGuardService } from './services/common/deactivate-guard.service';
import { AdminLogiDashboardsComponent } from './analytics/admin-logi-dashboards/admin-logi-dashboards.component';
import { AnalyticshomeComponent } from './analytics/analyticshome.component';
import { AnalyticBuilderComponent } from './analytics/analytic-builder/analytic-builder.component';
import { AnalyticSchedulerComponent } from './analytics/analytic-scheduler/analytic-scheduler.component';
import { AnalyticDashboardsComponent } from './analytics/analytic-dashboards/analytic-dashboards.component';
import { RegistrationConfigurationComponent } from './administration/registration-configuration/registration-configuration.component';
import { MyReviewsComponent } from './common/my-reviews/my-reviews.component';
import { ScheduleReviewComponent } from './common/schedule-review/schedule-review.component';
import { WorkflowstateconfigComponent } from './common/workflowstateconfig/workflowstateconfig.component';
import { ApplicationViewComponent } from './common/application-view/application-view.component';
import { ApplicationTypeSummaryComponent } from './common/application-type-summary/application-type-summary.component';

const routes: Routes = [
  {
    path: 'home', component: HomeComponent, data: { breadcrumb: 'Home' },
    canActivate: [AuthGuard],
    children: [

      // IST
      {
        path: 'ist', component: IstComponent, data: { breadcrumb: 'IST Dashboard' },
        children: [

          {
            path: 'applications',
            component: IstApplicationsComponent,
            data: { breadcrumb: 'All Applications' },
            children: [
              {
                path: 'application-ext/:id',
                component: IstApplicationExtComponent,
                data: { breadcrumb: 'Request' },
                children: [
                  { path: 'general_information_request', component: IstGeneralInformationComponent, data: { breadcrumb: 'General Information' } , canDeactivate: [DeactivateGuardService]},
                  { path: 'study_team_team_request', component: IstStudyTeamTeamComponent, data: { breadcrumb: 'Study Team - Team' } },
                  { path: 'study_team_organisation_setup_request', component: IstStudyTeamOrganizationComponent, data: { breadcrumb: 'Study Team - Organisation Setup' } },
                  { path: 'institutional_reiew_board_request', component: IstInstitutionalReviewBoardComponent, data: { breadcrumb: 'Institutional Review Board' } , canDeactivate: [DeactivateGuardService] },
                  { path: 'concept_proposal_request', component: IstConceptProposalComponent, data: { breadcrumb: 'Concept Proposal' }, canDeactivate: [DeactivateGuardService] },
                  { path: 'all_requests', component: IstAllRequestsComponent, data: { breadcrumb: 'All Requests' } },
                  { path: 'milestones_request', component: IstMilestonesComponent, data: { breadcrumb: 'MileStones' } },
                  { path: 'study_reports_request', component: IstStudyReportsComponent, data: { breadcrumb: 'Study Reports' } },
                  { path: 'activities_and_seminars_request', component: IstActivitiesSeminarsComponent, data: { breadcrumb: 'Activities and Seminars' } },
                  { path: 'publications_Request', component: IstPublicationsComponent, data: { breadcrumb: 'Publications' } },
                  { path: 'amendments_request', component: IstAmendmentsComponent, data: { breadcrumb: 'Amendments' } },
                  { path: 'site_evaluation_request', component: IstSiteEvluationComponent, data: { breadcrumb: 'Site Evaluation' } },
                  { path: 'attachments_request', component: AttachmentsComponent, data: { breadcrumb: 'Attachments' } },
                  //{ path: 'documentTemplateDefinition', component: IstDocumentTemplateDefinitionComponent, data: { breadcrumb: 'Attachments' } },
                  { path: 'rfi_request', component: RfiComponent, data: { breadcrumb: 'Attachments' } },
                  { path: 'notes_request', component: NotesComponent, data: { breadcrumb: 'Attachments' } },
                  { path: 'faqView', component: FaqViewComponent, data: { breadcrumb: 'Attachments' } },
                  { path: 'correspondence_request', component: CorrespondenceComponent, data: { breadcrumb: 'Correspondence' } },
                  { path: 'documentTemplateView', component: DocumentTemplateComponent, data: { breadcrumb: 'Document' } },
                  { path: 'dynamicform/:code', component: DynamicFormsComponent, data: { breadcrumb: 'Dynamic IST' },canDeactivate: [DeactivateGuardService] },
                  { path: 'schedule_review', component: ScheduleReviewComponent, data: { breadcrumb: 'SchedulerReview' } },
                  { path: '**', component: IstGeneralInformationComponent }
                ]
              },
            ]
          },
          {
            path: 'my-applications',
            component: IstMyApplicationsComponent,
            data: { breadcrumb: 'My Applications' },
            children: [
              {
                path: 'application-ext/:id',
                component: IstApplicationExtComponent,
                data: { breadcrumb: 'Request' },
                children: [
                  { path: 'general_information_request', component: IstGeneralInformationComponent, data: { breadcrumb: 'General Information' },canDeactivate: [DeactivateGuardService] },
                  { path: 'study_team_team_request', component: IstStudyTeamTeamComponent, data: { breadcrumb: 'Study Team - Team' } },
                  { path: 'study_team_organisation_setup_request', component: IstStudyTeamOrganizationComponent, data: { breadcrumb: 'Study Team - Organisation Setup' } },
                  { path: 'institutional_reiew_board_request', component: IstInstitutionalReviewBoardComponent, data: { breadcrumb: 'Institutional Review Board' } , canDeactivate: [DeactivateGuardService] },
                  { path: 'concept_proposal_request', component: IstConceptProposalComponent, data: { breadcrumb: 'Concept Proposal' },canDeactivate: [DeactivateGuardService] },
                  { path: 'all_requests', component: IstAllRequestsComponent, data: { breadcrumb: 'All Requests' } },
                  { path: 'milestones_request', component: IstMilestonesComponent, data: { breadcrumb: 'MileStones' } },
                  { path: 'study_reports_request', component: IstStudyReportsComponent, data: { breadcrumb: 'Study Reports' } },
                  { path: 'activities_and_seminars_request', component: IstActivitiesSeminarsComponent, data: { breadcrumb: 'Activities and Seminars' } },
                  { path: 'publications_Request', component: IstPublicationsComponent, data: { breadcrumb: 'Publications' } },
                  { path: 'amendments_request', component: IstAmendmentsComponent, data: { breadcrumb: 'Amendments' } },
                  { path: 'site_evaluation_request', component: IstSiteEvluationComponent, data: { breadcrumb: 'Site Evaluation' } },

                  { path: 'attachments_request', component: AttachmentsComponent, data: { breadcrumb: 'Attachments' } },
                  //{ path: 'documentTemplateDefinition', component: IstDocumentTemplateDefinitionComponent, data: { breadcrumb: 'Attachments' } },

                  { path: 'rfi_request', component: RfiComponent, data: { breadcrumb: 'Attachments' } },
                  { path: 'notes_request', component: NotesComponent, data: { breadcrumb: 'Attachments' } },
                  { path: 'faqView', component: FaqViewComponent, data: { breadcrumb: 'Attachments' } },
                  { path: 'correspondence_request', component: CorrespondenceComponent, data: { breadcrumb: 'Correspondence' } },
                  { path: 'documentTemplateView', component: DocumentTemplateComponent, data: { breadcrumb: 'Document' } },
                  { path: 'dynamicform/:code', component: DynamicFormsComponent, data: { breadcrumb: 'Dynamic IST' },canDeactivate: [DeactivateGuardService] },
                  { path: 'schedule_review', component: ScheduleReviewComponent, data: { breadcrumb: 'SchedulerReview' } },
                  { path: '**', component: IstGeneralInformationComponent }
                ]
              },
            ]
          },          
        ]
      },

      // GRANTS
      {
        path: 'grants', component: GrantsComponent, data: { breadcrumb: 'Grants Dashboard' },
        children: [
          {
            path: 'applications',
            component: GrantsApplicationsComponent,
            data: { breadcrumb: 'All Applications' },
            children: [
              {
                path: 'application-ext/:id',
                component: GrantsApplicationExtComponent,
                data: { breadcrumb: 'Request' },
                children: [
                  { path: 'geninfocme', component: GrantsGeneralInformationComponent, data: { breadcrumb: 'General Information' },canDeactivate: [DeactivateGuardService] },
                  { path: 'grantInform', component: GrantsGrantInformationComponent, data: { breadcrumb: 'Grant Information' },canDeactivate: [DeactivateGuardService] },
                  { path: 'genInformcharitable', component: GrantsGeneralInformationCharitableComponent, data: { breadcrumb: 'General Information' },canDeactivate: [DeactivateGuardService] },
                  { path: 'genInformsponsorship', component: GrantsGeneralInformationSponsorshipComponent, data: { breadcrumb: 'General Information' },canDeactivate: [DeactivateGuardService] },
                  { path: 'dfsponbenfit/:code', component: DynamicFormsComponent, data: { breadcrumb: 'Sponsorship Benefits' } },
                  { path: 'delivery_format', component: GrantsDeliveryFormatComponent, data: { breadcrumb: 'Delivery Format' }, canDeactivate: [DeactivateGuardService] },
                  { path: 'audiences', component: GrantsAudiencesComponent, data: { breadcrumb: 'Audiences' } },
                  { path: 'budget', component: GrantsBudgetComponent, data: { breadcrumb: 'Budget' } },
                  { path: 'dfaccred/:code', component: DynamicFormsComponent, data: { breadcrumb: 'Accredation details' } },
                  { path: 'authorized_signee_and_payee', component: GrantsAuthorizedSigneeAndPayeeComponent, data: { breadcrumb: 'Authorized Signee And Payee' } },
                  { path: 'outcome_assessment', component: GrantsOutcomeAssessmentComponent, data: { breadcrumb: 'Outcome Assessment' } },
                  { path: 'reconciliation', component: GrantsReconciliationComponent, data: { breadcrumb: 'Reconciliation' } },
                  //{ path: 'sponsorship_benefits', component: GrantsSponsershipBenefitsComponent, data: { breadcrumb: 'Sponsorship Benefits' } },
                  //{ path: 'sponsorship_benefits_sponsorship', component: GrantsSponsershipBenefitsComponent, data: { breadcrumb: 'Sponsorship Benefits (Sponsorship)' } },
                  { path: 'document_upload', component: GrantsDocumentUploadSponsorshipComponent, data: { breadcrumb: 'Document Upload' } },
                  { path: 'document_upload_sponsorship', component: GrantsDocumentUploadSponsorshipComponent, data: { breadcrumb: 'Document Upload (Sponsorship)' } },

                  { path: 'attachments_request', component: AttachmentsComponent, data: { breadcrumb: 'Attachments' } },
                  { path: 'documentTemplateView', component: DocumentTemplateComponent, data: { breadcrumb: 'Document' } },
                  { path: 'rfi_request', component: RfiComponent, data: { breadcrumb: 'Attachments' } },
                  { path: 'notes_request', component: NotesComponent, data: { breadcrumb: 'Attachments' } },
                  { path: 'correspondence_request', component: CorrespondenceComponent, data: { breadcrumb: 'Correspondence' } },
                  { path: 'faqView', component: FaqViewComponent, data: { breadcrumb: 'Attachments' } },
                  { path: 'dynamicform/:code', component: DynamicFormsComponent, data: { breadcrumb: 'Dynamic Grants' },canDeactivate: [DeactivateGuardService] },
                  { path: 'schedule_review', component: ScheduleReviewComponent, data: { breadcrumb: 'SchedulerReview' } },
                  { path: '**', component: GrantsGeneralInformationComponent }
                ]
              },
            ]

          },
          {
            path: 'my-applications',
            component: GrantsMyApplicationsComponent,
            data: { breadcrumb: 'My Applications' },
            children: [
              {
                path: 'application-ext/:id',
                component: GrantsApplicationExtComponent,
                data: { breadcrumb: 'Request' },
                children: [
                  { path: 'geninfocme', component: GrantsGeneralInformationComponent, data: { breadcrumb: 'General Information' } ,canDeactivate: [DeactivateGuardService]},
                  { path: 'grantInform', component: GrantsGrantInformationComponent, data: { breadcrumb: 'Grant Information' },canDeactivate: [DeactivateGuardService] },
                  { path: 'genInformcharitable', component: GrantsGeneralInformationCharitableComponent, data: { breadcrumb: 'General Information' },canDeactivate: [DeactivateGuardService] },
                  { path: 'genInformsponsorship', component: GrantsGeneralInformationSponsorshipComponent, data: { breadcrumb: 'General Information' },canDeactivate: [DeactivateGuardService] },
                  { path: 'dfsponbenfit/:code', component: DynamicFormsComponent, data: { breadcrumb: 'Sponsorship Benefits' } ,canDeactivate: [DeactivateGuardService]},
                  { path: 'delivery_format', component: GrantsDeliveryFormatComponent, data: { breadcrumb: 'Delivery Format' }, canDeactivate: [DeactivateGuardService] },
                  { path: 'audiences', component: GrantsAudiencesComponent, data: { breadcrumb: 'Audiences' } },
                  { path: 'budget', component: GrantsBudgetComponent, data: { breadcrumb: 'Budget' } },
                  { path: 'dfaccred/:code', component: DynamicFormsComponent, data: { breadcrumb: 'Accredation details' },canDeactivate: [DeactivateGuardService] },
                  { path: 'authorized_signee_and_payee', component: GrantsAuthorizedSigneeAndPayeeComponent, data: { breadcrumb: 'Authorized Signee And Payee' } },
                  { path: 'outcome_assessment', component: GrantsOutcomeAssessmentComponent, data: { breadcrumb: 'Outcome Assessment' } },
                  { path: 'reconciliation', component: GrantsReconciliationComponent, data: { breadcrumb: 'Reconciliation' } },
                  //{ path: 'sponsorship_benefits', component: GrantsSponsershipBenefitsComponent, data: { breadcrumb: 'Sponsorship Benefits' } },
                  //{ path: 'sponsorship_benefits_sponsorship', component: GrantsSponsershipBenefitsComponent, data: { breadcrumb: 'Sponsorship Benefits (Sponsorship)' } },
                  { path: 'document_upload', component: GrantsDocumentUploadSponsorshipComponent, data: { breadcrumb: 'Document Upload' } },
                  { path: 'document_upload_sponsorship', component: GrantsDocumentUploadSponsorshipComponent, data: { breadcrumb: 'Document Upload (Sponsorship)' } },

                  { path: 'attachments_request', component: AttachmentsComponent, data: { breadcrumb: 'Attachments' } },
                  { path: 'documentTemplateView', component: DocumentTemplateComponent, data: { breadcrumb: 'Document' } },

                  { path: 'rfi_request', component: RfiComponent, data: { breadcrumb: 'Attachments' } },
                  { path: 'notes_request', component: NotesComponent, data: { breadcrumb: 'Attachments' } },
                  { path: 'faqView', component: FaqViewComponent, data: { breadcrumb: 'Attachments' } },
                  { path: 'correspondence_request', component: CorrespondenceComponent, data: { breadcrumb: 'Correspondence' } },
                  { path: 'dynamicform/:code', component: DynamicFormsComponent, data: { breadcrumb: 'Dynamic Grants' },canDeactivate: [DeactivateGuardService] },
                  { path: 'schedule_review', component: ScheduleReviewComponent, data: { breadcrumb: 'SchedulerReview' } },
                  { path: '**', component: GrantsGeneralInformationComponent }
                ]
              },
            ]
          },
        ]
      },


      // EAP
      {
        path: 'eap', component: EapComponent, data: { breadcrumb: 'EAP Dashboard' },
        children: [
          {
            path: 'applications',
            component: EapApplicationsComponent,
            data: { breadcrumb: 'All Applications' },
            children: [
              {
                path: 'application-ext/:id',
                component: EapApplicationExtComponent,
                data: { breadcrumb: 'Request' },
                children: [
                  { path: 'program_info', component: EapProgramInfoComponent, data: { breadcrumb: 'Program Info' }},
                  { path: 'study_team_team', component: EapStudyTeamTeamComponent, data: { breadcrumb: 'Study Team - Team' } },
                  { path: 'study_team_org_setup', component: EapStudyTeamOrganizationComponent, data: { breadcrumb: 'Study Team Org Setup' } },
                  { path: 'institutional_review_board', component: EapInstitutionalReviewBoardComponent, data: { breadcrumb: 'Institutional Review Board' }, canDeactivate: [DeactivateGuardService] },
                  { path: 'study_reports', component: EapStudyReportsComponent, data: { breadcrumb: 'Study Reports' } },
                  { path: 'amendments', component: EapAmendmentsComponent, data: { breadcrumb: 'Amendments' } },

                  { path: 'attachments_request', component: AttachmentsComponent, data: { breadcrumb: 'Attachments' } },
                  { path: 'documentTemplateView', component: DocumentTemplateComponent, data: { breadcrumb: 'Document' } },

                  { path: 'rfi_request', component: RfiComponent, data: { breadcrumb: 'Attachments' } },
                  { path: 'notes_request', component: NotesComponent, data: { breadcrumb: 'Attachments' } },
                  { path: 'faqView', component: FaqViewComponent, data: { breadcrumb: 'Attachments' } },
                  { path: 'correspondence_request', component: CorrespondenceComponent, data: { breadcrumb: 'Correspondence' } },
                  { path: 'all_requests', component: EapAllRequestsComponent, data: { breadcrumb: 'All Requests', from: "eap" } },
                  { path: 'dynamicform/:code', component: DynamicFormsComponent, data: { breadcrumb: 'Dynamic EAP' } },
                  { path: 'schedule_review', component: ScheduleReviewComponent, data: { breadcrumb: 'SchedulerReview' } },
                  { path: '**', component: EapProgramInfoComponent }
                ]
              },
            ]
          },
          {
            path: 'my-applications',
            component: EapMyApplicationsComponent,
            data: { breadcrumb: 'My Applications' },
            children: [
              {
                path: 'application-ext/:id',
                component: EapApplicationExtComponent,
                data: { breadcrumb: 'Request' },
                children: [
                  { path: 'program_info', component: EapProgramInfoComponent, data: { breadcrumb: 'Program Info' } },
                  { path: 'study_team_team', component: EapStudyTeamTeamComponent, data: { breadcrumb: 'Study Team - Team' } },
                  { path: 'study_team_org_setup', component: EapStudyTeamOrganizationComponent, data: { breadcrumb: 'Study Team Org Setup' } },
                  { path: 'institutional_review_board', component: EapInstitutionalReviewBoardComponent, data: { breadcrumb: 'Institutional Review Board' } },
                  { path: 'study_reports', component: EapStudyReportsComponent, data: { breadcrumb: 'Study Reports' } },
                  { path: 'amendments', component: EapAmendmentsComponent, data: { breadcrumb: 'Amendments' } },

                  { path: 'attachments_request', component: AttachmentsComponent, data: { breadcrumb: 'Attachments' } },
                  { path: 'documentTemplateView', component: DocumentTemplateComponent, data: { breadcrumb: 'Document' } },

                  { path: 'rfi_request', component: RfiComponent, data: { breadcrumb: 'Attachments' } },
                  { path: 'notes_request', component: NotesComponent, data: { breadcrumb: 'Attachments' } },
                  { path: 'faqView', component: FaqViewComponent, data: { breadcrumb: 'Attachments' } },
                  { path: 'correspondence_request', component: CorrespondenceComponent, data: { breadcrumb: 'Correspondence' } },
                  { path: 'all_requests', component: EapAllRequestsComponent, data: { breadcrumb: 'All Requests', from: "eap" } },
                  { path: 'dynamicform/:code', component: DynamicFormsComponent, data: { breadcrumb: 'Dynamic EAP' } },
                  { path: 'schedule_review', component: ScheduleReviewComponent, data: { breadcrumb: 'SchedulerReview' } },
                  { path: '**', component: EapProgramInfoComponent }
                ]
              },
            ]
          }
        ]
      },

      // UM
      {
        path: 'um', component: UmComponent, data: { breadcrumb: 'UM Dashboard' },
        children: [
          {
            path: 'organization',
            component: UmOrganizationComponent,
            data: { breadcrumb: 'Organization' }
          },
          {
            path: 'department',
            component: UmDepartmentComponent,
            data: { breadcrumb: 'Department' }
          },
          {
            path: 'role',
            component: UmRoleComponent,
            data: { breadcrumb: 'Role' }
          },
          {
            path: 'user',
            component: UmUserComponent,
            data: { breadcrumb: 'User' }
          },
          {
            path: 'superaminauditlog',
            component: SuperAdminAuditLogComponent,
            data: { breadcrumb: 'Super Admin Audit Log' }
          },
          {
            path: 'superaminemailconfig',
            component: SuperAdminEmailconfigComponent,
            data: { breadcrumb: 'Super Admin Email Config' }
          },
        ]
      },
        // analytics
        {
          path: 'analytics', component: AnalyticshomeComponent, data: { breadcrumb: 'analytics' },
          children: [
            {
              path: 'dashboards',
              component: AnalyticDashboardsComponent,
              data: { breadcrumb: 'dashboards' }
            },
            {
              path: 'dashboardbuilder',
              component: AnalyticBuilderComponent,
              data: { breadcrumb: 'dashboardbuilder' }
            },
            {
              path: 'schedular',
              component: AnalyticSchedulerComponent,
              data: { breadcrumb: 'schedular' }
            },
            {
              path: 'admindashboards',
              component: AdminLogiDashboardsComponent,
              data: { breadcrumb: 'admindashboards' }
            }
          ]
        },

      // Dashboard
      {
        path: 'dashboard', component: UmComponent, data: { breadcrumb: 'UM Dashboard' },
        children: [
          {
            path: 'genov',
            component: GeneraloverviewComponent,
            data: { breadcrumb: 'genov' }
          },
          {
            path: 'listing',
            component: ListingComponent,
            data: { breadcrumb: 'listing' }
          }
        ]
      },
      // Administration
      {
        path: 'administration', component: AdministrationComponent, data: { breadcrumb: 'Administration' },
        children: [
          { path: 'istRegistrations', component: IstRegistrationsComponent, data: { breadcrumb: 'Registrations', type:'ist' } },
          { path: 'eapRegistrations', component: IstRegistrationsComponent, data: { breadcrumb: 'Registrations', type:'eap' } },
          { path: 'grantsRegistrations', component: GrantsRegistrationsComponent, data: { breadcrumb: 'Registrations' } },
          { path: 'eapType', component: EapTypeComponent, data: { breadcrumb: 'EAP Type' } },
          { path: 'lookups', component: LookupsComponent, data: { breadcrumb: 'Lookups' } },
          { path: 'faq', component: FaqComponent, data: { breadcrumb: 'FAQ' } },
          { path: 'product', component: ProductComponent, data: { breadcrumb: 'Product' } },
          { path: 'program', component: ProgramComponent, data: { breadcrumb: 'Program' } },
          { path: 'c_code', component: CCodeComponent, data: { breadcrumb: 'Ccode' } },
          { path: 'registrationconfig', component: RegistrationConfigurationComponent, data: { breadcrumb: 'Registration Configuration' }, canDeactivate: [DeactivateGuardService] },
          { path: 'email_configuration', component: EmailSetUpSummaryComponent, data: { breadcrumb: 'Email Configuration' } },
          { path: 'policy_configurator/:code', component: PolicyConfiguratorComponent, data: { breadcrumb: 'Policy Configurator' }, canDeactivate: [DeactivateGuardService] },
          { path: 'instructions', component: InstructionsComponent, data: { breadcrumb: 'Instructions' } },
          { path: 'screen_repository/:code', component: ScreenRepositoryComponent, data: { breadcrumb: 'Screen Repository' } },
          { path: 'documentTemplateDefinition', component: IstDocumentTemplateDefinitionComponent, data: { breadcrumb: 'Attachments' } },
          { path: 'productnetworklocation', component: ProductNetworkLocationsComponent, data: { breadcrumb: 'Network Location' } },
          { path: 'hlookups', component: HlookupsComponent, data: { breadcrumb: 'H-Lookups' } },
          { path: 'loginlog', component: LoginLogComponent, data: { breadcrumb: 'User Login Log' } },
          { path: 'adminconsole', component: AdminConsoleComponent, data: { breadcrumb: 'Admin Console' } },
          { path: 'adminauditMain', component: AdminAuditlogMainComponent, data: { breadcrumb: 'Admin Audit Trail' } },
          { path: 'alertsandnotifications/:code', component: AlertsAndNotificationsSummaryComponent, data: { breadcrumb: 'Alerts & Notifications' } },
          { path: 'emailtemplates', component: EmailTemplatesSummaryComponent, data: { breadcrumb: 'Email Templates' } },
          {path: 'iegauditlogmain/:code', component: IEGAuditlogMainComponent, data: { breadcrumb: 'Audit Logs' } },
          {path: 'myreviews', component: MyReviewsComponent, data: { breadcrumb: 'My Reviews' } },
          {path: 'iegstateconfig/:code', component: WorkflowstateconfigComponent, data: { breadcrumb: 'Workflow state configuration' }},
          {path: 'applicationtype', component: ApplicationTypeSummaryComponent, data: { breadcrumb: 'Application Types' }}
        ]
      },

      // Personalization
      {
        path: 'personalization', component: PersonalizationComponent, data: { breadcrumb: 'Personalization' },
        children: [
          { path: 'changeTheme', component: ChangeThemeComponent, data: { breadcrumb: 'Change Theme' } },
          { path: 'changePassword', component: ChangePasswordComponent, data: { breadcrumb: 'Change Password' } },
          { path: 'viewProfile', component: ViewProfileComponent, data: { breadcrumb: 'View Profile' } }//,
         // { path: 'expandemail', component: ExpandEmailComponent, data: { breadcrumb: 'Expand Email' } },
        ]
      },



      // notifications store
      { path: 'notifications_store', component: NotificationStoreComponent, data: { breadcrumb: 'Notifications Store' } },
    ]
  },

  // other screens
  { path: 'expandemail', component: ExpandEmailComponent,   
    data: { breadcrumb: 'Expand Email' },
    canActivate: [AuthGuard]
  },
  { path: 'filepreview/:fileid/:type/:filename', component: FilePreviewComponent,   
    data: { breadcrumb: 'File preview' }
    
  },
  { path: ':code/login', component: LoginComponent, data: { breadcrumb: 'Login' } },
  { path: 'login', component: LoginComponent, data: { breadcrumb: 'Login' } },
  { path: 'forgot_password/:id', component: ForgotPasswordComponent, data: { breadcrumb: 'Forgot Password' } },
  { path: '404/:message', component: ErrorPageComponent, data: {breadcrumb: '404'}},
  { path: 'applicationview/:appid/:moduleid', component: ApplicationViewComponent, data: { breadcrumb: 'Application View' } },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', component: ErrorPageComponent, data: {breadcrumb: '404'} }
];
const options = { relativeLinkResolution: 'legacy' }
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
